// Stores the topology tuple used to filter the isobar list, or null for no filter.
const IsobarViewFilterReducer = (state = null, action) => {
    switch (action.type) {
        case 'SET_ISOBAR_VIEW_FILTER':
            return action.payload;
        case 'CLEAR_ISOBAR_VIEW_FILTER':
            return null;
        default:
            return state;
    }
};

export default IsobarViewFilterReducer;
